import { useLayoutEffect } from 'react'
import setAds from '@utils/setAds'
import { useIsAppControl } from '@store/isApp'
import { Box } from '@mui/joy'
import pxToRem from '@utils/pxToRem'
import AsideAdWrapper from '@components/ads/Article/Aside/AsideAdWrapper'
import useIsShowAds from '@hooks/ads/useIsShowAds'
import useVideoAdController from '@hooks/ads/useVideoAdController'

const BodyVideoPcAd = () => {
	const { isApp } = useIsAppControl()
	const { isShowDesktop } = useIsShowAds()

	const isShowAd = !isApp && isShowDesktop

	useVideoAdController({ isShowAd })

	useLayoutEffect(() => {
		if (isApp) {
			return
		}

		setAds({ mode: 'digitalcamp', id: '4xB0YbaMF7hRoa9Z|MTg3' })
	}, [isApp])

	return (
		<AsideAdWrapper
			sx={{
				display: isShowAd ? 'block' : 'none',
				margin: `${pxToRem(48)} 0`,
				overflow: 'hidden',
				padding: `${pxToRem(10)} 0 ${pxToRem(30)} !important`,
			}}
		>
			<Box id="4xB0YbaMF7hRoa9Z|MTg3_AD">
				<Box id="pub_sspdcamp_ad_MTg3" />
			</Box>
		</AsideAdWrapper>
	)
}
export default BodyVideoPcAd
